import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';
import { IOrMiniCtaBlockDProps } from './or-mini-cta-block-d';
import { EIcons } from '../or-video-hero/or-video-hero.types';

export const orMiniCtaBlockDMockData = [
  {
    top_spacing: 'xs',
    bottom_spacing: 'xs',
    body_copy: '<p>This is body text</p>',
    theme: 'LIGHT',
    heading_element: 'h2',
    heading_variant: 'h2',
    heading: 'Test Heading',
    image: {
      aspectRatio: { mobile: '16/9', tablet: '16/9', desktop: '16/9' },
      src: {
        mobile:
          'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blt15020674fc4e5339/67cf1f163d548789c20eeea2/visit_design_center.jpg?branch=develop',
        tablet: '',
        desktop: '',
      },
      alt: 'Test Image',
    },
    top_cta: {
      label: 'Top CTA',
      href: '/top',
      variant: EClickableVariants.PRIMARY,
      interactLocation: 'top',
      outline: true,
      icon: EIcons.PLAY,
    },
    bottom_cta: {
      label: 'Bottom CTA',
      href: '/bottom',
      variant: EClickableVariants.PRIMARY,
      interactLocation: 'top',
      outline: true,
    },
  } as IOrMiniCtaBlockDProps,
];
